import Vue from 'vue'

Vue.filter('to_credits', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
  })
  return formatter.format(value)
})
